import { IWorkbenchSetting } from '@framework/workbench/setting/workbench-setting.interface';
import { IWorkbenchSettings } from '@tencent/workbench';
import { PLATFORM_MOBILE } from '@framework/workbench/const/mobile-setting-const';
import { CutController } from '@framework/workbench/ui/cut/cut-controller';
import { PasteController } from '@framework/workbench/ui/paste/paste-controller';
import { CopyController } from '@framework/workbench/ui/copy/copy-controller';
import { DeleteController } from '@framework/workbench/ui/delete/delete-controller';
import { MoveSlideUpController } from '@framework/workbench/ui/move-slide-up/move-slide-up-controller';
import { MoveSlideDownController } from '@framework/workbench/ui/move-slide-down/move-slide-down-controller';
import { AllSelectController } from '@framework/workbench/ui/all-select/all-select-controller';
import { EditController } from '@framework/workbench/ui/edit/edit-controller';
import { RotateController } from '@src/framework/workbench/ui/rotate-mobile/rotate-controller';
import { AIController } from '@src/framework/workbench/ui/ai-mobile/ai-controller';
import { AiGeneratePageMobileController } from '@src/framework/workbench/ui/ai-generate-page-mobile/ai-generate-page-mobile-controller';
import { HideSlideController } from '@framework/workbench/ui/hide-slide/hide-slide.controller';
import { AIReplaceSlideController } from '../../ui/ai-replace-slide-mobile/ai-replace-slide-controller';
import ContextMenuDismissFeature from '@framework/workbench/common/feature/context-menu-dismiss-feature';

/**
 * Mobile workbench配置项管理基类，主要用于生成PC的workbench配置。
 */
export default abstract class BaseMobileWorkbenchSetting implements IWorkbenchSetting {
    public createSettings(): IWorkbenchSettings<'mobile'> {
        return {
            platform: PLATFORM_MOBILE,
            titlebar: {
                disabled: true,
            },
            toolbar: {
                disabled: true,
            },
            contextMenu: {
                schema: this.getContextMenuSchema(),
                multiRows: true,
            },
            mount: {
                controllers: this.getController(),
                services: this.getServices(),
                features: this.getFeatures(),
            },
        };
    }

    protected getController(): Function[] {
        return [
            CutController,
            PasteController,
            CopyController,
            DeleteController,
            MoveSlideUpController,
            MoveSlideDownController,
            AllSelectController,
            EditController,
            RotateController,
            AIController,
            AiGeneratePageMobileController,
            HideSlideController,
            AIReplaceSlideController,
        ];
    }

    protected getServices(): Function[] {
        return [

        ];
    }

    protected getFeatures(): Function[] {
        return [
            ContextMenuDismissFeature,
        ];
    }

    /**
     * 获取context menu schema，子类实现
     * @protected
     */
    protected abstract getContextMenuSchema(): string[];
}
